import React , { createContext, useContext, useState, useEffect } from 'react';
import { XMarkIcon, RocketLaunchIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import { useOnboarding } from '../../contexts/OnboardingProvider';

export const OnboardingBanner = () => {
    const { hasCompletedOnboarding, startTutorial } = useOnboarding();
    const [dismissed, setDismissed] = useState(false);

    // Don't show if onboarding is complete or banner is dismissed
    if (hasCompletedOnboarding || dismissed) {
        return null;
    }

    return (
        <div className="bg-gradient-to-r from-blue-500 to-purple-600 shadow-sm">
            <div className="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between flex-wrap">
                    <div className="w-0 flex-1 flex items-center">
            <span className="flex p-2 rounded-lg bg-blue-800">
              <RocketLaunchIcon className="h-6 w-6 text-white" />
            </span>
                        <p className="ml-3 font-medium text-white">
              <span className="md:inline">
                Welcome to PostMgr! Get started with our quick 5-minute setup tutorial.
              </span>
                        </p>
                    </div>
                    <div className="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
                        <button
                            onClick={startTutorial}
                            className="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-blue-600 bg-white hover:bg-blue-50"
                        >
                            Start Tutorial
                        </button>
                    </div>
                    <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
                        <button
                            type="button"
                            onClick={() => setDismissed(true)}
                            className="-mr-1 flex p-2 rounded-md hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2"
                        >
                            <XMarkIcon className="h-6 w-6 text-white" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
